import styled from 'styled-components';

import { LoadingSpinner } from '@/components/to-blokkie/loading-spinner/loading-spinner';

const FullPageLoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;

  > img {
    width: 64px;
    height: 64px;
    transform: none;
  }
`;

export function FullPageLoader() {
  return (
    <FullPageLoaderContainer>
      <LoadingSpinner />
    </FullPageLoaderContainer>
  );
}
